import { FC, PropsWithChildren, useState } from 'react';

import { Header } from '../templates/header/header';
import { AdminSidebar } from './sidebar.layout';

export const AdminLayout: FC<PropsWithChildren> = ({ children }) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    return (
        <div className="relative flex">
            <AdminSidebar
                isCollapsed={isCollapsed}
                setIsCollapsed={setIsCollapsed}
            />

            <div className="relative flex w-full min-w-0 flex-auto flex-col">
                <Header
                    setIsCollapsed={setIsCollapsed}
                    isCollapsed={isCollapsed}
                />
                <div className="flex h-full flex-auto flex-col">{children}</div>
            </div>
        </div>
    );
};

AdminLayout.displayName = 'AdminLayout';
